export default {
	orders: {
		loading: "Chargement des commandes...",
		noOrders: "Aucune commande pour le moment",
		states: {
			ordered: "Commandé",
			delivered: "Livré",
			paid: "Terminé",
			inProduction: "En production",
			produced: "En expédition",
			invoiced: "Facture envoyée",
			cancelled: "Annulé",
			creditOverdrawn: "Limite de crédit dépassée",
			unknown: "Inconnu",
			dueDateLabel: "Date de livraison départ usine",
		},
		kommission: {
			placeholder: "Vous pouvez saisir ici votre numéro de commande",
			placeholderShort: "Saisir …",
			label: "Numéro de commande",
			yourNumberLabel: "Votre numéro de commande :",
			yourNumberShortLabel: "Votre n° de commande",
		},
		orderIdLabel: "Commande Blexon",
		carrierLabel: "Transporteur",
		trackingLabel: "Suivi de l'envoi",
		orderConfirmation: {
			downloadTooltip: "Télécharger la confirmation de commande au format PDF",
			label: "Confirmation de commande",
			fileName: "Confirmation de commande {orderId}.pdf",
		},
		invoice: {
			downloadTooltip: "Télécharger la facture au format PDF",
			label: "Facture",
			fileName: "Facture pour la commande {orderId}.pdf",
		},
		prepayInvoice: {
			downloadTooltip: "Télécharger la facture d'acompte au format PDF",
			label: "Facture d'acompte",
			fileName: "Facture d'acompte {invoiceId}.pdf",
		},
		pageTitle: "Historique des commandes",
		loadingArchive: "Chargement de l'historique des commandes …",
		searchPlaceholder: "Rechercher par n° de commande, votre n° de commande ou id d'article …",
		filterAriaLabel: "Filtrer par type",
		filterAll: "Tout",
		filterOrders: "Commandes",
		filterCredits: "Avoirs",
		noEntriesFound: "Aucune entrée trouvée",
		noCreditsYet: "Aucun avoir pour le moment",
		adjustSearchHint: "Ajustez la recherche ou le filtre.",
		creditPillTooltip:
			"Total de vos avoirs ouverts. Sera automatiquement déduit de votre prochaine facture.",
		availableCredit: "Solde disponible",
		thumbsTooltip: "Articles de cette commande",
		articleCountSuffix: "articles",
		detailsButton: "Détails",
		orderTypeTag: "Commande",
		orderTitle: "Commande {number} du {date}",
		certificatesSuffix: " / Certificats",
		creditNote: {
			typeTag: "Avoir",
			unassignedChip: "Sans lien avec une commande",
			stateRefunded: "Remboursé",
			stateSettled: "Déduit",
			stateOpen: "Ouvert",
			unassignedNote:
				"Cet avoir n'est lié à aucune commande et sera déduit de votre prochaine facture.",
			settledNextInvoiceNote: "Sera déduit de votre prochaine facture.",
			numberLabel: "N° d'avoir",
			dateLabel: "Date",
			referenceLabel: "Référence",
			referenceOrder: "Commande {orderId}",
			noReference: "Aucune commande",
			settledOnLabel: "Déduit sur",
			invoiceReference: "Facture {invoiceId}",
			downloadTooltip: "Télécharger l'avoir au format PDF",
			downloadButton: "Avoir",
			fileName: "Avoir {creditNoteId}.pdf",
		},
		details: "Détails",
		detailsWithCertificates: "Détails / Certificats",
		cancellation: {
			inReview: "Annulation en cours d'examen",
			show: "Afficher l'annulation",
			completed: "Annulation terminée",
			processing: "Annulation en cours de traitement",
			cancelButton: "Annuler",
			orderCancelledSuccess: "La commande a été annulée avec succès.",
			orderAlreadyProcessed: "La commande a entre-temps été traitée.",
			cancelFailed: "La commande n'a pas pu être annulée.",
		},
		changeDeliveryAddress: "Modifier l'adresse de livraison",
		changeInvoiceAddress: "Modifier l'adresse de facturation",
		loadMore: {
			tooltip: "Charge d'autres commandes.",
			button: "Charger plus",
		},
		confirmCancellationDialog: {
			title: "Confirmer l'annulation",
			text: "Le traitement de cette commande n'a pas encore commencé.",
			text2: "Dans ce cas, une annulation est possible gratuitement. Seule la commande entière peut toutefois être annulée. Si nécessaire, la commande devra être passée à nouveau.",
			cancelButton: "Annuler",
			confirmButton: "Annuler la commande",
		},
		messages: {
			kommissionSaved: "Le numéro de commande a été enregistré.",
			kommissionSaveError: "Le numéro de commande n'a pas pu être enregistré.",
		},
	},
	orderDetail: {
		backToOrders: "Historique des commandes",
		orderHeading: "Commande {orderId}",
		certificatesAvailable: {
			title: "Certificats disponibles",
			subtitle: "Télécharger les certificats matière 3.1 pour cette commande.",
			button: "Certificat 3.1 · Article {articleId}",
		},
		orderDataTitle: "Données de la commande",
		orderReceivedLabel: "Réception de la commande",
		yourOrderNumberShortLabel: "Votre numéro de commande",
		noOrderNumberShort: "aucune indication",
		expectedDeliveryDateShortLabel: "Date de livraison prévue (départ usine)",
		expectedCompletionShortLabel: "Achèvement prévu",
		trackingLabelShort: "Suivi de l'envoi",
		invoiceAddressCardTitle: "Adresse de facturation",
		positionsCardTitle: "Positions",
		tableShort: {
			posAbbr: "Pos.",
			totalAbbr: "Total ({currency})",
		},
		titleLabel: "Confirmation de la commande {orderId}",
		orderDateLabel: "Réception de la commande :",
		yourOrderNumberLabel: "Votre numéro de commande :",
		noOrderNumber: "aucune indication (vous pouvez la modifier dans l'historique des commandes)",
		expectedDeliveryDateLabel: "Date de livraison prévue (départ usine) :",
		trackingEmailInfo:
			"Une fois la commande terminée, vous recevrez un e-mail contenant un lien de suivi de l'envoi.",
		expectedCompletionLabel: "Achèvement prévu :",
		pickupImportantLabel: "Important :",
		pickupEmailInfo:
			"Vous recevrez un e-mail dès que votre commande sera prête à être retirée. Le retrait n'est possible qu'après réception de cet e-mail.",
		invoiceAddressLabel: "Adresse de facturation :",
		pickupAddressLabel: "Adresse de retrait",
		deliveryAddressLabel: "Adresse de livraison",
		pickupAddressName: "Retrait",
		priceModel: {
			standard: "(Livraison rapide)",
			slow: "(Livraison à prix optimisé)",
			express: "(Livraison express)",
		},
		table: {
			position: "Position",
			quantity: "Quantité",
			preview: "Aperçu",
			description: "Description",
			pricePerUnit: "Prix/pce",
			totalPrice: "Prix total ({currency})",
		},
		engraving: "Gravure",
		deburring: "Ébavurage :",
		preCoated: "pré-apprêté",
		certificateLink: "Certificat 3.1",
		vatLabel: "TVA ({rate} %)",
		totalLabel: "Total",
		certificateErrorDialog: {
			title: "Impossible de charger le certificat",
			text: "Le certificat ne peut pas être chargé actuellement. Le service semble indisponible.",
			text2: "Veuillez contacter notre assistance.",
			closeButton: "Fermer",
		},
	},
	ticket: {
		tooltip: "Ouvre la boîte de dialogue permettant de saisir une réclamation pour cette commande.",
		deadlinePassedTooltip: "Le délai de réclamation est écoulé. Veuillez contacter notre assistance.",
		createButton: "Saisir une réclamation",
		showButton: "Afficher la réclamation",
	},
	editTicketPosition: {
		blexonIdLabel: "Id Blexon :",
		materialLabel: "Matériau :",
		preCoated: "pré-apprêté",
		engraving: "Gravure",
		introText:
			"Pour pouvoir traiter votre réclamation rapidement et simplement, nous avons besoin de quelques informations pour chaque position.",
		complainTypeQuestion: "De quel type est votre réclamation ?",
		selectPlaceholder: "Veuillez sélectionner",
		uploadPhotosQuestion: "Téléchargez des photos qui montrent la réclamation le plus clairement possible",
		deleteImageTooltip: "Supprimer l'image",
		minOneImageHint: "Au moins une image doit être téléchargée.",
		affectedPartsQuestion: "Combien de pièces de cette position sont concernées ?",
		allButton: "Toutes",
		partsCountLabel: "Nombre de pièces",
		complaintDescriptionQuestion: "Que réclamez-vous ?",
		complaintDescriptionLabel: "Réclamation",
		expectationQuestion: "Qu'attendez-vous de nous ?",
		expectationLabel: "Attente",
		messages: {
			requiredField: "Doit être indiqué.",
			enterValue: "Veuillez indiquer une valeur",
			minimumOne: "Au moins 1",
			maximum: "Maximum {max}",
			maxImagesExceeded: "Vous pouvez télécharger 10 images au maximum.",
			imageUploadError:
				"L'image ne peut pas être lue. Veuillez utiliser une image au format jpg, png ou gif. En cas de problème, veuillez contacter info@blexon.com.",
		},
	},
	requestCancellation: {
		orderNotFound: "La commande n'a pas pu être trouvée.",
		titleLabel: "Demander l'annulation de la commande #{orderId}",
		alreadyProcessedWarning: "Le traitement de la commande a malheureusement déjà commencé.",
		introText:
			"Cette commande est déjà en cours de traitement. Une annulation peut néanmoins être demandée.",
		introText2:
			"Nous clarifions les coûts déjà engagés et vous contactons par e-mail. Vous déciderez ensuite quelles positions de la commande vous souhaitez définitivement annuler.",
		feeNoticePart1:
			"Même si, après clarification des coûts, vous renoncez à l'annulation, des frais de traitement de",
		feeNoticePart2: "sont dus dès que vous demandez une annulation.",
		selectArticlesText: "Veuillez sélectionner les articles à annuler :",
		table: {
			position: "Position",
			quantity: "Quantité",
			preview: "Aperçu",
			description: "Description",
			pricePerUnit: "Prix / pce",
			priceTotal: "Prix total",
		},
		blexonIdLabel: "Id Blexon :",
		acceptCostsLabel:
			"J'accepte les frais de traitement forfaitaires de {currency} {fixCost}.-, dus lors de la demande d'annulation.",
		forceCancellationLabel:
			"FACULTATIF ! Je souhaite annuler définitivement les positions sélectionnées, indépendamment des coûts engagés. Je confirme prendre en charge tous les frais d'annulation des positions ainsi que le forfait d'annulation et renoncer aux pièces.",
		contactInfoText1: "Nous vous informerons au sujet de cette annulation à l'adresse",
		contactInfoText2:
			"Si vous souhaitez être contacté à une autre adresse e-mail, vous pouvez l'indiquer ici :",
		altContactEmailLabel: "Adresse e-mail alternative",
		cancelButton: "Annuler",
		forceCancelButton: "Annuler définitivement",
		requestCancelButton: "Demander l'annulation",
		altContactButton: {
			useStandard: "Utiliser les coordonnées standard",
			useAlternative: "Utiliser des coordonnées alternatives",
		},
		messages: {
			fixCostLoadError: "Le forfait d'annulation n'a pas pu être chargé.",
			positionsLoadError: "Les positions de la commande n'ont pas pu être chargées.",
			cancellationRequested: "L'annulation a été demandée.",
			cancellationRequestError: "L'annulation n'a pas pu être demandée.",
			requiredField: "Doit être indiqué.",
			invalidEmail: "E-mail non valide.",
		},
	},
	cancellationConfirmation: {
		requestNotFound: "La demande d'annulation n'a pas pu être trouvée.",
		alreadyProcessed: "Cette demande d'annulation a déjà été traitée.",
		titleLabel: "Confirmer l'annulation de la commande #{orderId}",
		introText: "Vous avez demandé l'annulation de certaines positions de cette commande.",
		introText2:
			"Les coûts de l'annulation sont listés ci-dessous par position. Vous pouvez sélectionner les positions que vous souhaitez annuler. Les coûts seront ajustés en conséquence. Les positions non annulées seront traitées normalement. Le forfait d'annulation pour les clarifications déjà effectuées dans le cadre de l'annulation est dans tous les cas dû et est inclus dans les coûts.",
		table: {
			articleId: "Id article",
			position: "Position",
			preview: "Aperçu",
			description: "Description",
			cancellationCost: "Coûts d'annulation",
		},
		flatFeeLabel: "Forfait d'annulation",
		totalLabel: "Total",
		backButton: "Retour",
		doNotCancelButton: "Ne pas annuler",
		cancelSelectedButton: "Annuler les positions sélectionnées",
		messages: {
			loadCancellationError: "Les données d'annulation n'ont pas pu être chargées.",
			loadOrderError: "Les données de la commande n'ont pas pu être chargées.",
			confirmError: "L'annulation n'a pas pu être confirmée.",
		},
	},
	choosePosition: {
		introText: "Veuillez sélectionner toutes les positions concernées par cette réclamation.",
		table: {
			position: "Position",
			image: "Image",
			description: "Description",
			quantity: "Quantité",
			unitPrice: "Prix unitaire",
			total: "Total",
		},
		blexonIdLabel: "Id Blexon :",
		materialLabel: "Matériau :",
		preCoated: "pré-apprêté",
		engraving: "Gravure",
	},
	createTicket: {
		titleLabel: "Réclamation concernant la commande {orderId}",
		stepper: {
			choosePositions: "Sélectionner les positions",
			positionAbbrev: "Pos",
			position: "Position",
			contactData: "Coordonnées",
			confirmation: "Confirmation",
		},
		emailNoticePart1: "Nous vous enverrons un e-mail à",
		emailNoticePart2:
			", dès que le statut de cette réclamation changera. En cas de questions, nous vous appellerons au",
		emailNoticePart3: ".",
		altContactPrompt:
			"Si vous souhaitez être contacté différemment pour le traitement de cette réclamation, vous pouvez indiquer des coordonnées alternatives :",
		altContactEmailLabel: "Adresse e-mail alternative",
		altContactPhoneLabel: "Numéro de téléphone alternatif",
		altContactButton: {
			useStandard: "Utiliser les coordonnées standard",
			useAlternative: "Utiliser des coordonnées alternatives",
		},
		missingInfoText: "Veuillez compléter les informations manquantes afin de créer le ticket.",
		table: {
			position: "Position",
			image: "Image",
			blexonId: "Id Blexon",
			complainedCount: "# Réclamées",
			name: "Nom",
			complaint: "Réclamation",
			expectation: "Attente",
		},
		correspondenceToLabel: "Correspondance à :",
		replacementDelivery: "Livraison de remplacement",
		backButton: "Retour",
		nextButton: "Suivant",
		finishButton: "Terminer",
		ticketBlockedHint:
			"Cette réclamation est déjà en cours de traitement. Veuillez contacter info@blexon.com pour toute assistance supplémentaire.",
		leaveDialog: {
			title: "Avertissement de perte de données",
			text: "Les modifications seront perdues si vous quittez cette page.",
		},
		messages: {
			requiredField: "Doit être indiqué.",
			invalidEmail: "E-mail non valide.",
			saveSuccess: "La réclamation a été enregistrée avec succès.",
			saveError: "Erreur lors de l'enregistrement. Veuillez contacter info@blexon.com.",
			orderNotFound: "Impossible de créer le ticket. Commande introuvable.",
		},
	},
};
